import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import {
  homeTileDtoSchema,
  type HomeTileDto,
  type HomeTileKey,
} from '@tg-hookah/shared/dto';
import { api } from '@/lib/api';

const listSchema = z.array(homeTileDtoSchema);

async function fetchHomeTiles(): Promise<HomeTileDto[]> {
  const res = await api.get('/home-tiles');
  return listSchema.parse(res.data);
}

export function useHomeTiles() {
  return useQuery({
    queryKey: ['home-tiles'],
    queryFn: fetchHomeTiles,
    staleTime: 60_000,
  });
}

/** Convert list → map keyed by HomeTileKey for O(1) lookup in render. */
export function tilesByKey(
  list: HomeTileDto[] | undefined,
): Partial<Record<HomeTileKey, string | null>> {
  const out: Partial<Record<HomeTileKey, string | null>> = {};
  for (const t of list ?? []) out[t.key] = t.imageUrl;
  return out;
}
